<template>
  <div>
    <div class="text-center depahead rsu">Profile</div>
    <div style="max-width: 500px; margin-left: auto; margin-right: auto">
      <v-layout row wrap justify-end>
        <div class="submitbtn" style="width: 170px;margin-left: auto;margin-right: 0;">
          <v-btn :loading="logoutloading" text @click="logout" class="text-capitalize" color="primary" block>Log
            out</v-btn>
        </div>
      </v-layout>
      <v-container style="font-weight: 600; line-height: 25px; position: relative" class="px-6 pt-0">
        <div v-if="$store.state.profiledata.status == 'confirm'">
          <v-card class="pa-3 pt-12 mt-12" elevation="5" style="position: relative">
            <div style="position: absolute; right: 7px; top: 6px">
              <v-chip outlined color="primary" small>{{ data.membertype ? data.membertype : "-" }}</v-chip>
            </div>
            <div class="text-center" style="
                position: absolute;
                left: 26%;
                top: -50px;
                transform: translate(-50%, 0);
              ">
              <v-avatar class="elevation-4" style="border: 2px solid white; background-color: white" size="90">
                <v-img :src="data.profile_pic"></v-img>
              </v-avatar>
            </div>
            <component :data="data" :is="membertype"></component>
          </v-card>
        </div>
        <div v-else>
          <div class="my-10">
            <div class="text-center mb-3" style="font-weight: 600; font-size: 21px">
              คุณยังไม่ได้ยืนยันตัวตน
            </div>
            <v-btn @click="query.view = 'Verifyinfo'" block outlined color="primary" style="font-weight: 600">
              ยืนยันตัวตน
            </v-btn>
          </div>
        </div>
      </v-container>
      <v-flex xs12 class="px-6 mt-5">
        <v-btn style="font-size:19px" outlined @click="gotoHistoryList" color="primary" large
          block>ประวัติการสมัคร</v-btn>
      </v-flex>
      <v-flex xs12 class="px-6 mt-5">
        <v-btn style="font-size:19px" outlined @click="cancelMember" color="red" large block>ยกเลิกการเป็นสมาชิก</v-btn>
      </v-flex>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import NoTaxID from "./NoTaxID";
import TaxID from "./TaxID.vue";
import Regular from "./Regular.vue";
import University from "./University.vue";
export default {
  components: {
    NoTaxID,
    TaxID,
    Regular,
    University,
  },
  data() {
    return {
      loading: false,
      logoutloading: false,
    };
  },
  mounted() {
    // this.getProfile();
  },
  computed: {
    data() {
      return this.$store.state.profiledata;
    },
    membertype() {
      if (this.data.verification == "บุคคลธรรมดา" || this.data.verification == "เกษตรกร") {
        return Regular;
      } else if (this.data.verification == "มี Tax ID") {
        return TaxID;
      } else if (this.data.membertype == "มหาวิทยาลัย") {
        return University;
      } else {
        return NoTaxID;
      }
    },
  },
  methods: {
    gotoHistoryList() {
      this.$store.state.query.view = "HistoryList";
    },
    async cancelMember() {
      let vm = this;
      var result = await this.$swal.fire({
        title: "ท่านต้องการยกเลิกการเป็นสมาชิกหรือไม่",
        text: "หากท่านยืนยันการยกเลิก ข้อมูลสมาชิกของท่านจะถูกลบออกจากระบบ",
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#F42222",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      });
      if (result.value) {
        axios
          .post(
            vm.serverUrl + "liff/delete/depamember/" + parseInt(vm.data.memberid),
            { userid: vm.userid },
            {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            }
          )
          .then((res) => {
            if (res && res.data && res.data.responsecode) {
              vm.$liff.closeWindow();
            } else {
              this.$swal.fire({
                title: "ยกเลิกสมาชิกไม่สำเร็จ",
              });
            }
          });
      }
    },
    async logout() {
      this.$swal
        .fire({
          text: "ต้องการออกจากระบบ ?",
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
          confirmButtonColor: "#152d53",
          cancelButtonColor: "grey",
        })
        .then(async (result) => {
          if (result.value) {
            this.logoutloading = true;
            axios
              .post(
                this.serverUrl + "depalogout",
                { userid: this.userid, memberid: this.$store.state.memberid },
                {
                  headers: {
                    AUTHORIZATION: "Bearer xxx xxx",
                  },
                }
              )
              .then(async (response) => {
                this.logoutloading = false;
                if (response.data.responsecode == 200) {
                  await this.$store.dispatch("sendMessage", "ออกจากระบบแล้ว");
                  if (response.data.responsecode != 300) {
                    await this.$liff.closeWindow();
                  }
                } else {
                  this.$swal.fire({
                    texxt: response.data.reason,
                  });
                }
              });
          }
        });
    },
  },
};
</script>

<style lang="scss">
.titleprofile {
  color: grey !important;
  font-size: 12px;
}

.subprofile {
  line-height: 12px;
  font-size: 17px;
  margin-bottom: 10px;
  font-weight: 500;
}
</style>